import React from "react";
import './End.css'
const End = () => {
  return (
  <div>
<div class="end">
    <div class="service"><a href="#">서비스이용약관</a></div>
    <div class="map"><a href="#">위치정보 이용약관</a></div>
    <div class="trade"><a href="#">전자금융거래 이용약관</a></div>
    <div class="notice"><a href="#">개인정보 처리방침</a></div>
  </div>
  <div class="end_text">
  <p>완벽한 하루는 통신판매 중개자이며 통신판매의 당사자가 아닙니다.<br/>
    
    따라서 완벽한 하루는 상품거래정보 및 거래에 대한 책임을 지지 않습니다.</p>
  </div>
  <div className="gopofo"><a href="https://junmovo.github.io/Portfolio/"><span>포트폴리오</span> 바로가기</a></div>
  </div>
  );
};

export default End;
